
export type SendNotificationRequestType = typeof SendNotificationRequestType[keyof typeof SendNotificationRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendNotificationRequestType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
